import { signOut } from '../session';

/**
 * A credential that authenticated but has no place in this application.
 *
 * Machine clients exist for systems, not for people: they hold a client id and
 * secret, and they call the API directly. If one ever reaches a browser, saying
 * so plainly is better than a navigation with nothing in it.
 */
export function NoWebAccessPage() {
  return (
    <div className="page page--centred">
      <div className="notice" role="alert">
        <h1 className="notice__title">Esta credencial não usa o sistema pela web</h1>
        <p className="notice__body">
          Credenciais de integração conversam diretamente com a API e não têm telas. Para entrar
          pela web, use uma conta de pessoa.
        </p>
        <div className="notice__actions">
          <button type="button" className="button button--primary" onClick={signOut}>
            Entrar com outra conta
          </button>
        </div>
      </div>
    </div>
  );
}
